/* eslint-disable no-constant-binary-expression */
import { FC } from 'react';
import { clsx } from 'clsx';

import { ICardGroupScheduleProps } from '../models/types';

import styles from './styles.module.scss';

export const CardGroupSchedule: FC<ICardGroupScheduleProps> = ({ data }) => {
  return (
    <div className={styles['card-schedule']}>
      <div className={styles['card-schedule__container']}>
        <div
          className={clsx(
            styles['card-schedule__row'],
            styles['card-schedule__row-1'],
          )}
        >
          <span className={styles['card-schedule__disctype']}>
            {data.disciplType}
          </span>
          <span className={styles['card-schedule__disctime']}>
            {data.disciplTime}
          </span>
        </div>
        {data.subgroupNum && (
          <div className={styles['card-schedule__subgroup']}>
            Подгруппа {data.subgroupNum}
          </div>
        )}
        <div
          className={clsx(
            styles['card-schedule__row'],
            styles['card-schedule__row-2'],
          )}
        >
          <span className={styles['card-schedule__discname']}>
            {data.disciplName}
          </span>
        </div>
        <div
          className={clsx(
            styles['card-schedule__row'],
            styles['card-schedule__row-3'],
          )}
        >
          <span className={styles['card-schedule__building-auditory']}>
            {data.location}
          </span>
        </div>
        {!!data.dateDayTags?.length && (
          <div className={styles['card-schedule__tags']}>
            {data.dateDayTags.map((tag) => {
              return (
                <div className={styles['card-schedule__tag']} key={tag}>
                  {tag}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};
